import React from 'react';
import { observer } from 'mobx-react';
import { NikoCorporateListTemplate } from 'themes/application/niko-corporate/pages';
import { setCurrentView } from 'core/utils';
import { NikoCorporateListViewStore } from 'application/niko-corporate/stores';

@setCurrentView((rootStore) => new NikoCorporateListViewStore(rootStore), 'listViewStore')
@observer
class NikoCorporateList extends React.Component {
    render() {
        return <NikoCorporateListTemplate {...this.props} />
    }
}

export default NikoCorporateList;
